import { render, staticRenderFns } from "./chartjs.vue?vue&type=template&id=61165f86&scoped=true"
import script from "./chartjs.vue?vue&type=script&lang=js"
export * from "./chartjs.vue?vue&type=script&lang=js"
import style0 from "./chartjs.vue?vue&type=style&index=0&id=61165f86&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61165f86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61165f86')) {
      api.createRecord('61165f86', component.options)
    } else {
      api.reload('61165f86', component.options)
    }
    module.hot.accept("./chartjs.vue?vue&type=template&id=61165f86&scoped=true", function () {
      api.rerender('61165f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chartjs-view/chartjs.vue"
export default component.exports